import { render, staticRenderFns } from "./ForgotPassword-2.vue?vue&type=template&id=137674b2&scoped=true&"
import script from "./ForgotPassword-2.vue?vue&type=script&lang=js&"
export * from "./ForgotPassword-2.vue?vue&type=script&lang=js&"
import style0 from "./ForgotPassword-2.vue?vue&type=style&index=0&id=137674b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137674b2",
  null
  
)

export default component.exports